export const mapDataChanges = (data, fieldsToIgnore) => {
    return data.map((v, index) => {
        const changes = []
        if (index > 0) {
            const previous = data[index - 1];
            const current = data[index];
            for (const [key, value] of Object.entries(current)) {
                if (!fieldsToIgnore.includes(key) && value !== previous[key]) {
                    changes.push({ fieldName: key, previousValue: previous[key], currentValue: current[key] })
                }
            }
        }
        const newObj = { ...v, changes }
        return newObj;
    })
}

export const mapCrmHistory = (data, isReceipt) => {
    if(data && data.length > 0) {
        const receiptField = [
            "notificationDate",
            "replayId",
            "type",
            "createdOn",
            "lastModifiedById",
            "id",
            "changes"
        ]
        const submissionFields = [
            "notificationDate",
            "replayId",
            "type",
            "submissionFinishedOn",
            "submissionStartedOn",
            "createdOn",
            "id",
            "valuationHistoryId",
            "changes"
        ]
        const fieldsToIgnore = isReceipt ? receiptField : submissionFields;
        return mapDataChanges(data, fieldsToIgnore);
    }
}